import React from "react";
import { 
  Button, 
  Card,
  CardBody,
  Input,
  Typography } from "@material-tailwind/react";

function tagToSlug(tag) {
  return tag.toLowerCase().replace(/\s/g, '-');
}

export default function RightSidenav({ recentPosts, topTags }) {
  return (
    <>
      <Card className="mt-6">
        <CardBody>
        <form
          action="https://gmail.us13.list-manage.com/subscribe/post?u=2343d646c60fd2780c7858d3b&amp;id=aae21e5fd9&amp;f_id=00c88fe4f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="mt-4 lg:mt-0"
          target="_self"
          noValidate
        >
          <div className="mt-6 w-full lg:mt-0">
            <Input
              required
              type="email"
              name="EMAIL"
              id="mce-EMAIL"
              placeholder="Enter your email"
              className="!border-[1.5px] !border-blue-gray-50 !bg-white !px-4 text-primary !ring-transparent placeholder:text-gray-600 focus:!border-primary focus:!border-t-primary focus:ring-primary/20"
              labelProps={{
                className: "hidden",
              }}
              containerProps={{ className: "min-w-[100px]" }}
            />
          </div>
            <Button
              size="sm"
              color="blue-gray"
              type="submit"
              name="subscribe"
              id="mc-embedded-subscribe"
              className="shrink-0 bg-primary text-base font-medium capitalize md:w-full mt-4"
            >
              Subscribe
            </Button>
        </form>
        </CardBody>
      </Card>
      <Card className="mt-6">
        <CardBody>
          <Typography variant="h6" color="blue-gray" className="mb-4 uppercase">
            Recommended Topics
          </Typography>
          {topTags && topTags.length > 0 && (
            topTags.map((tag, index) => (
              <div key={index} className="flex items-center justify-between mb-2">
                <a href={`/blog/tag/${tagToSlug(tag.tag)}`}>
                  <Typography variant="paragraph" color="blue-gray" className="hover:font-normal">{tag.tag.replace(/-/g, ' ')}</Typography>
                </a>
                <Typography variant="small" color="blue-gray">{tag.count}</Typography>
              </div>
            ))
          )}

        </CardBody>
      </Card>
      <Card className="mt-6">
        <CardBody>
          <Typography variant="h6" color="blue-gray" className="mb-4 uppercase">
            Latest Blogposts
          </Typography>
          {recentPosts && recentPosts.length > 0 && (
            <ul>
              {recentPosts.slice(0, 5).map((post) => (
                <li className="mb-4" key={post.slug.join("/")}>
                  <a href={`/blog/${post.slug.join("/")}`}>
                    <Typography variant="paragraph" color="blue-gray">{post.frontMatter.title}</Typography>
                  </a>
                </li>
              ))}
            </ul>
          )}
        </CardBody>
      </Card>
    </>
  );
}
